import React, { Component } from 'react';
import styled from 'styled-components';

import { GlobalStyles } from './style';
import Header from './Components/Header';
import Main from './Components/Main';

class App extends Component {
  render() {
    return (
      <>
        <GlobalStyles />
        <Wrapper>
          <Header />
          <Main />
        </Wrapper>
      </>
    );
  }
}

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  min-width: 600px;
  min-height: 600px;
  display: flex;
  flex-direction: column;
`;

export default App;
